__turbopack_context__.v({
  "statusBadge": "CallStatusBadge-module__6b7Hoq__statusBadge",
  "statusDone": "CallStatusBadge-module__6b7Hoq__statusDone",
  "statusError": "CallStatusBadge-module__6b7Hoq__statusError",
  "statusPending": "CallStatusBadge-module__6b7Hoq__statusPending",
  "statusProcessing": "CallStatusBadge-module__6b7Hoq__statusProcessing",
});
